// extracted by mini-css-extract-plugin
var _1 = "webpack-containers-Organizations-Insights-module__heading";
var _2 = "webpack-containers-Organizations-Insights-module__message";
export { _1 as "heading", _2 as "message" }
